import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material'
import authService from 'Services/api/auth.service'
import AppDialogTitle from 'components/Dialog/AppDialogTitle'
import CloseDialogButton from 'components/Dialog/CloseDialogButton'
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { showErrorMessage } from 'store/actions/ui.action'
import { finalizeUserLoginFlow } from 'store/authCommon'

interface Props {
    onClose: () => void
}

function ExceedLoginWarningDialog({ onClose }: Props) {
    const dispatch = useDispatch()
    const history = useHistory()
    const [processing, setProcessing] = useState(false)

    const handleOnForceLogin = useCallback(async () => {
        try {
            setProcessing(true)
            const authResult = (
                await authService.issueRealAccessToken({ forceLogout: true })
            ).data
            await finalizeUserLoginFlow(authResult, dispatch, history)

            onClose()
            setProcessing(false)
        } catch (err) {
            dispatch(showErrorMessage(err))
        }
    }, [dispatch, history, onClose])

    return (
        <Dialog open onClose={() => {}}>
            <AppDialogTitle text="Existing Session Detected" />
            <CloseDialogButton
                dialogName="exceed log in warning dialog"
                onClick={onClose}
            />
            <DialogContent>
                <Typography>
                    You're already logged in on another POS terminal. Please log
                    out there, or use the Force Logout option here to end that
                    session.
                </Typography>
                <Typography variant="subtitle2" fontStyle="italic">
                    Be cautious: forcing a logout could interrupt active
                    transactions.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={onClose} disabled={processing}>
                    Cancel
                </Button>
                <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleOnForceLogin}
                    disabled={processing}
                >
                    Force logout
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ExceedLoginWarningDialog
